import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function buildFormat() {
      var $toc = $('<div />', {id: 'toc_container'});
      var $list = $('<ul />', {class: 'toc_list'});
      var $groups = $('.u-format-group');
      // フォーマットグループごとの処理
      for (var i = 0; i < $groups.length; i++) {
        var $_list = $('<ul />');
        var $group = $($groups[i]);
        var group_title = $group.find('.u-format-group__title').text();
        var $group_li = $('<li />');
        var groupid = 'formatgroup_' + (i + 1);
        $group.attr('id', groupid);
        $list.append(
          $group_li.append(
            $('<a />',
              {
                text: (i + 1) + '. ' + group_title,
                href: '#' + groupid
              }
            )
          )
        );
        // フォーマットごとの処理
        var $formats = $group.find('.u-format-group__content').find('.u-format');
        var $_ul = $('<ul />');
        for (var m = 0; m < $formats.length; m++) {
          var $format = $($formats[m]);
          var $format_title = $format.find('.u-format__title');
          var $format_content = $format.find('.u-format__content');
          var formatid = 'format_' + (i + 1) + (m + 1);
          $format.find('.u-format__title').attr('id', formatid);
          var format_title = $format_title.text();
          var format_number = (i + 1) + '.' + (m + 1) + '. ';
          $format_title.text(format_number + format_title);
          $_ul.append(
            $('<li />').append(
              $('<a />', {
                  href: '#' + formatid,
                  text: format_number + format_title
                }
              )
            )
          );

          // コードを追加
          var $code = $('<div />', {class: 'u-format__code'});
          $code.append($('<div />', {
            class: 'u-format__code__title',
            text: format_number + format_title
          }));
          var formathtml = $format.find('.u-format__content').html();
          $code.append($('<pre />', {text: formathtml.trim()}));
          $format.append($code);
        }
        $group_li.append($_ul);
        $_list.append($group_li);
        $list.append($_list);
      }
      $toc.append($list);
      $('.c-breadcrumb').after(
        $('<div />', {
            class: 'l-container'
          }
        ).append($toc)
      );
    }

    // メインビジュアル
    var owls = $('.owl-carousel');
    if (owls.length !== 0) {

      owls.imagesLoaded(function () {
        if ($('.c-main-visual').length === 0) {
          return false;
        }
        $('.c-main-visual').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          center: true,
          responsive: {
            0: {
              items: 1,
              nav: true,
              autoWidth: false,
              //navText: ['<img src="/acquisition/wp-content/themes/nf-corporation-acquisition-html/dist/assets/images/icon-slider-prev_sp.png" />', '<img src="/acquisition/wp-content/themes/nf-corporation-acquisition-html/dist/assets/images/icon-slider-next_sp.png" />'],
            },
            1212: {
              nav: false,
              items: 1,
              autoWidth: true,
              //navText: ['<img src="/acquisition/wp-content/themes/nf-corporation-acquisition-html/dist/assets/images/icon-slider-prev.png" />', '<img src="/acquisition/wp-content/themes/nf-corporation-acquisition-html/dist/assets/images/icon-slider-next.png" />'],
            }
          }
        });
      });

    }
    $(".c-products-page__sub").hover(function () {
      var imageName = $(this).css("background-image");
      $('.c-products-page__sub').removeClass('is-active');
      $(this).addClass('is-active');
      console.log(imageName);
      $('.c-products-page__main').css('background-image', imageName);
    })


    $(".js-footer-accordion").on('click', function () {
      var win = $(window).innerWidth();
      if (win < 950) {
        event.preventDefault();
        $(this).toggleClass('is-active');
        $(this).next('.l-footer__menu__list').slideToggle();
      }
    });

    $(".c-sidemenu__title").on('click', function () {
      var win = $(window).innerWidth();
      if (win < 950) {
        event.preventDefault();
        $(this).toggleClass('is-active');
        $(this).next('.c-sidemenu__list').slideToggle();
      }
    })
    // フローティングバナー
    // フローティングバナー
    $('.c-fixed-bnr-sp__close a').on('click', function (e) {
      e.preventDefault();
      $(this).parents('.c-fixed-bnr-sp').addClass('is-close');
      $('.l-footer').css('margin-bottom', 0);
    });
    // $('.c-fixed-bnr').clone(true).appendTo('#clone');
    // var documentHeight = $(document).height(); //ページ全体の高さ
    // var footerTop = $('.c-footer-bnr').height(); //フッターの高さ
    // var contentTop = $('.l-footer').height(); //コンタクトブロックの高さ
    //
    // // 表示する/非表示のオフセット値
    // var visibleOffset = 500; //表示させる座標
    // var hiddenOffset = documentHeight - (contentTop + 200); //非表示にする座標
    // console.log(hiddenOffset);
    // //スクロールイベントが発生したら処理実行
    // $(window).on('scroll', function () {
    //
    //   //表示
    //   if ($(this).scrollTop() > visibleOffset) {
    //     $('#clone .c-fixed-bnr').addClass('is-fixed');
    //   }
    //
    //   //非表示
    //   if ($(this).scrollTop() > hiddenOffset) {
    //     $('#clone .c-fixed-bnr').removeClass('is-fixed');
    //   }
    //
    //   //表示
    //   if ($(this).scrollTop() < visibleOffset) {
    //     $('#clone .c-fixed-bnr').removeClass('is-fixed');
    //   }
    // });
  }
}

window.GApp = new App();
